import { createAsyncThunk } from '@reduxjs/toolkit'
import { CREATE_ORDER, ORDERS, SHOP_ORDERS, CALLBACKREQUEST, CALLBACK, PATCH_SHOP_ORDERS ,UPDATE_SCHEDULE} from '../../../axios/services'
import { API_ERROR } from '../../../global'
import { toast as message } from 'react-toastify'
import { getApi, patchApi,postApi } from '../../../axios'
import { PARTNERS } from '../../../axios/services'


const defaultOrderFilters = {
  sortBy: 'all',
  created: '',
  scheduled: '',
  state: '',
  page: 1,
  user_role: '',
  items_per_page: 10,
}



export const getPartners = createAsyncThunk('oms/getPartners', async (payload = {}, thunkAPI) => {
  try {

    const params = {
      order_id: payload?.id || '',
      page: payload?.page || 1,
      items_per_page: payload?.items_per_page || 10,
      created_on: payload?.created_at || '',
      location: payload?.location || '',
      is_available: payload?.is_available || '',
      verification_status: payload?.verification_status || '',
      // admin_roles: true,
    }
    const authData = JSON.parse(localStorage.getItem('auth') || 'null')
    const roles = authData?.role?.split(',').map((role) => role.trim()) || []
    const isSuperUser = roles.includes('coms_admin')


    if (isSuperUser) {
      params.admin_roles = 'coms_admin'
    }

    const queryString = new URLSearchParams(params).toString()

    const response = await getApi(`${PARTNERS}?${queryString}`)

    if (response?.data?.success) {
      return response?.data?.data
    }
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR)
    return thunkAPI.rejectWithValue(error.response?.data?.message)
  }
})




export const getOrders = createAsyncThunk('oms/getOrders', async (payload = {}, thunkAPI) => {
  try {
    const currentFilters = thunkAPI.getState()?.oms?.orderFilters || defaultOrderFilters
    const filters = {
      ...defaultOrderFilters,
      ...currentFilters,
      ...payload,
    }


    const queryParams = new URLSearchParams({
      sort_by: filters?.sortBy || 'all',
      created: filters?.created || '',
      scheduled: filters?.scheduled || '',
      state: filters?.state || '',
      admin_roles:"coms_admin",
      page: filters?.page?.toString() || '1',
      user_role: filters?.user_role || '',
      items_per_page: filters?.items_per_page?.toString() || '10',
    })

    // Add `admin_roles=coms_admin` if the user is coms_admin
    // if (isSuperUser) {
    //   queryParams.append('admin_roles', 'coms_admin')
    // }

    const response = await getApi(`${ORDERS}?${queryParams.toString()}`)
    console.log(response, 'Full API response =======================')

    if (response?.data?.success) {
      const orders = response?.data?.data?.orders || []
      const pagination = response?.data?.data?.pagination || {}

      console.log(pagination, orders, 'Orders List =======================')
      return { orders, pagination, filters}
    }
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR)
    return thunkAPI.rejectWithValue(error.response.data.message)
  }
})



export const getOrderById = createAsyncThunk('oms/getOrderById', async (payload = '', thunkAPI) => {
  try {
    const response = await getApi(CREATE_ORDER + '?order_id=' + payload)
    if (response?.data?.success) {
      return response?.data?.data
    }
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR)
    return thunkAPI.rejectWithValue(error.response.data.message)
  }
})

export const patchOrder = createAsyncThunk('oms/patchOrder',async ({ body, next, onError }, thunkAPI) => {
    try {
      const response = await patchApi(CREATE_ORDER, body)
      if (response?.data?.success) {
        next?.(response?.data)
        message.success(response?.data?.message)
      } 
      else {
        onError?.(response.data)
        return thunkAPI.rejectWithValue(response.data?.message || 'Failed')
      }

    } catch (error) {
      const errorData = error?.response?.data
      const errorMessage = errorData?.message || API_ERROR
      const statusCode = error?.response?.status

      if (statusCode === 400 && errorData?.success === true) {
        onError?.(errorData)
      } else {
        message.error(errorMessage)
        onError?.(errorData)
      }

      return thunkAPI.rejectWithValue(errorMessage)
    }

  }
)


export const updateschedule = createAsyncThunk('oms/updateschedule',async ({ body, next, onError }, thunkAPI) => {
  try {
    const response = await patchApi(UPDATE_SCHEDULE, body)
    if (response?.data?.success) {
      next?.(response?.data)
      message.success(response?.data?.message)
    } 
    else {
      onError?.(response.data)
      return thunkAPI.rejectWithValue(response.data?.message || 'Failed')
    }

  } catch (error) {
    const errorData = error?.response?.data
    const errorMessage = errorData?.message || API_ERROR
    const statusCode = error?.response?.status

    if (statusCode === 400 && errorData?.success === true) {
      onError?.(errorData)
    } else {
      message.error(errorMessage)
      onError?.(errorData)
    }

    return thunkAPI.rejectWithValue(errorMessage)
  }

}
)

export const postOrder = createAsyncThunk('oms/postOrder',async ({ body, next, onError }, thunkAPI) => {
  try {
    const response = await postApi (CREATE_ORDER, body)
    
    if (response?.data?.success) {
      next?.()
      message.success(response?.data?.message)
    } 
  } catch (error) {
    const errorData = error?.response?.data
    const errorMessage = errorData?.message || API_ERROR
    const statusCode = error?.response?.status

    if (statusCode === 400 && errorData?.success === true) {
      onError?.(errorData)
    } else {
      message.error(errorMessage)
      onError?.(errorData)
    }

    return thunkAPI.rejectWithValue(errorMessage)
  }

}
)

export const patchRequest = createAsyncThunk('oms/patchRequest', async ({ body, next }, thunkAPI) => {
  try {
    const response = await patchApi(CALLBACK, body)
    if (response?.data?.success) {
      next()
      message.success(response?.data?.message)
    }
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR)
    return thunkAPI.rejectWithValue(error.response.data.message)
  }
})

export const getShopOrders = createAsyncThunk('oms/getShopOrders', async (payload = {}, thunkAPI) => {
  try {
    const params = {
      sort_by: payload?.sortBy || 'all',
      created: payload?.created || '',
      scheduled: payload?.scheduled || '',
      state: payload?.state || '',
      page: payload?.page || 1,
      user_role: payload?.user_role || '',
      items_per_page: 10,
    }
  const authData = JSON.parse(localStorage.getItem('auth') || 'null')
  const roles = authData?.role?.split(',').map((role) => role.trim()) || []
  const isSuperUser = roles.includes('coms_admin')


    if (isSuperUser) {
      params.admin_roles = 'coms_admin'
    }

    const queryString = new URLSearchParams(params).toString()
    const response = await getApi(`${SHOP_ORDERS}?${queryString}`)

    if (response?.data?.success) {
      return response?.data
    }
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR)
    return thunkAPI.rejectWithValue(error?.response?.data?.message)
  }
})



export const getShopOrderById = createAsyncThunk('oms/getShopOrderById', async (payload = '', thunkAPI) => {
  try {
    const response = await getApi(PATCH_SHOP_ORDERS + '?order_id=' + payload)
    if (response?.data?.success) {
      // console.log(response?.data,'666666666666666666666666666666666666666666666666666666666666')
      return response?.data?.data
    }
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR)
    return thunkAPI.rejectWithValue(error.response.data.message)
  }
})

export const patchshoporder = createAsyncThunk('oms/patchshoporder', async ({body, next}, thunkAPI) => {
  try {
    const response = await patchApi(PATCH_SHOP_ORDERS, body)
    if (response?.data?.success) {
      next()
      message.success(response?.data?.message)
    }
  } catch (error) {
    message.error(error?.response?.data?.message || API_ERROR)
    return thunkAPI.rejectWithValue(error.response.data.message)
  }
})





export const get_Callbackreuest = createAsyncThunk(
  'oms/get_Callbackreuest',
  async (payload, thunkAPI) => {
    try {
      const response = await getApi(
        `${CALLBACKREQUEST}?page=${payload?.page || 1}&items_per_page=${
          payload?.items_per_page || 10
        }`
      )

      if (response?.data?.success) {
        console.log(response?.data, '*********************************************')
        return response?.data
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR)
      return thunkAPI.rejectWithValue(error.response.data.message)
    }
  }
)
